import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../../apis/transform/stats"
import cx from "classnames"
import style from "./style.module.scss"
import { Progress } from "antd"

export function PlayerShots({ shots, shotsOnTarget }: { shots: number; shotsOnTarget: number }) {
  return (
    <div className={style.playerShotsContainer}>
      <Row className={cx(style.playerShotsRow, style.whiteBg)}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Tiri</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(shots)}</dd>
          </Col>
        </dl>
      </Row>
      <Row className={style.playerShotsRow}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Tiri in porta</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(shotsOnTarget)}%</dd>
          </Col>
          <Col>
            <Progress
              percent={shotsOnTarget}
              size="small"
              showInfo={false}
              strokeLinecap={"square"}
              strokeColor={"#f4c400"}
              trailColor="white"
            />
          </Col>
        </dl>
      </Row>
    </div>
    // <Col className={"colStats"}>
    //   <Row>
    //     <Col sm={6} className={"centerColumn"}>
    //       <Row>
    //         <Col className={"competitionSeasonValueLarge"}>{statNumberToString(shots)}</Col>
    //       </Row>
    //       <Row>
    //         <Col className={"competitionSeasonLabel"}>
    //           <h2>Tiri</h2>
    //         </Col>
    //       </Row>
    //     </Col>
    //     <Col sm={6} className={"centerColumn"}>
    //       <Row>
    //         <Col className={"competitionSeasonValue"}>{`${statNumberToString(shotsOnTarget)}%`}</Col>
    //       </Row>
    //       <Row>
    //         <Col>
    //           <Progress
    //             className={"paddingLeftRight15"}
    //             percent={shotsOnTarget}
    //             size="small"
    //             showInfo={false}
    //             strokeLinecap={"square"}
    //             strokeColor={"#f4c400"}
    //           />
    //         </Col>
    //       </Row>
    //       <Row>
    //         <Col className={"competitionSeasonLabel"}>
    //           <h2>Tiri in porta</h2>
    //         </Col>
    //       </Row>
    //     </Col>
    //   </Row>
    // </Col>
  )
}
